/** @jsxImportSource theme-ui */
import { jsx } from "theme-ui";
import React, { Component } from "react";
import PropTypes from "prop-types";
import { Heading, Box } from "@theme-ui/components";
import posed from "react-pose";
import { FaChevronUp, FaChevronDown } from "react-icons/fa";
import { Icon } from "../atoms";
import { colors } from "../../styles/theme";

const AccordionBody = posed.div({
  closed: { height: 0 },
  open: { height: "auto" },
});

class AccordionSection extends Component {
  onClick = () => {
    const { onClick, index, label } = this.props;
    if (index >= 0) {
      onClick(index);
    } else {
      onClick(label);
    }
  };

  onHover = () => {
    const { activateOnHover } = this.props;
    if (activateOnHover) {
      this.onClick();
    }
  };

  render() {
    const {
      onClick,
      onHover,
      props: {
        bg,
        isOpen,
        label,
        as,
        style,
        children,
        textStyle,
        richResultSectionProps,
        richResultQuestionProps,
        showChevronIcon,
        openIconName = "ChevronUp",
        closeIconName = "ChevronDown",
        iconSize = 32,
        iconColor = colors.neutral500,
        showUnderlinedQuestion,
        isElement,
        Element,
      },
    } = this;

    const color = bg && isOpen ? "white" : "secondary2";
    const accordianLabel =
      typeof label === "string" ? label : <this.props.label {...this.props} />;
    const icon = isOpen ? (
      <Icon name={openIconName} size={iconSize} color={iconColor} pointerCursor sx={{ ml: 2 }} className="open-icon" />
    ) : (
      <Icon name={closeIconName} size={iconSize} color={iconColor} pointerCursor sx={{ ml: 2 }} className="close-icon" />
    );
    const backgroundColor = bg && isOpen ? "#22B4FB" : "inherited";
    const questionUnderline = showUnderlinedQuestion
      ? "1px dotted #AAA"
      : "none";

    return (
      <div
        sx={{
          mb: 3,
          px: [2, 2, 3, 4],
          py: 2,
          color,
          backgroundColor,
          borderRadius: "3px",
          ...style,
        }}
        className="accordion-section"
        {...richResultSectionProps}
      >
        {isElement ? (
          <div onClick={onClick}>
            <Element />
          </div>
        ) : (
          <Heading
            variant="accordionHeading"
            as={as}
            onClick={onClick}
            onMouseEnter={onHover}
            sx={{
              cursor: "pointer",
              color,
              ...textStyle,
            }}
            className={isOpen ? "accordion-heading open" : "accordion-heading close"}
          >
            <span
              sx={{ borderBottom: questionUnderline }}
              className="accordion-label"
              {...richResultQuestionProps}
            >
              {accordianLabel}
            </span>
            {showChevronIcon && <span>{icon}</span>}
          </Heading>
        )}
        <AccordionBody
          sx={{ overflow: "hidden" }}
          pose={isOpen ? "open" : "closed"}
        >
          {children}
        </AccordionBody>
      </div>
    );
  }
}

AccordionSection.propTypes = {
  children: PropTypes.instanceOf(Object).isRequired,
  isOpen: PropTypes.bool.isRequired,
  label: PropTypes.any.isRequired,
  onClick: PropTypes.func.isRequired,
  style: PropTypes.object,
  textStyle: PropTypes.object,
  as: PropTypes.string,
  bg: PropTypes.bool,
  index: PropTypes.number,
  isElement: PropTypes.bool,
  Element: PropTypes.func
};

AccordionSection.defaultProps = {
  style: {},
  textStyle: {},
  as: "h3",
  bg: false,
  isElement: false,
};

export default AccordionSection;
